/*=========================================================================================
  File Name: moduleStatusMobileActions.js
  Description: Status Mobile Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";
import StatusMobile from "@/models/StatusMobile.js";

export default {
	// Consulta los estatus
	getStatus({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/status")
				.then((res) => {
					commit("SET_STATUS", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getOnlyStatus({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/status/${id}`)
				.then((res) => {
					commit("SET_STATUS_ONLY", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getStatusMobile({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/status/mobile")
				.then((res) => {
					commit("SET_STATUS_MOBILE", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getOnlyStatusMobile({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/status/mobile/${id}`)
				.then((res) => {
					//commit('ADD_STATUS_MOBILE', res.data)
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getCompanies({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/company")
				.then((res) => {
					commit("SET_COMPANIES", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Crea un estatus para movil
	addStatus({commit}, object) {
		return new Promise((resolve, reject) => {
			Api.post("/status/mobile", JSON.stringify(object))
				.then((response) => {
					//this.dispatch('moduleStatusMobile/getOnlyStatusMobile', response.data.id)
					const newStatusMobile = new StatusMobile(object);
					Object.assign(newStatusMobile, {id: response.data.id});
					commit("ADD_STATUS_MOBILE", newStatusMobile);
					//this.dispatch('moduleStatusMobile/getStatusMobile')
					//commit('SET_STATUS_ONLY', object)
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Actualiza el Status
	updateStatus({commit}, object) {
		let id = object.id;
		delete object["id"];
		return new Promise((resolve, reject) => {
			Api.put(`/status/mobile/${id}`, JSON.stringify(object))
				.then((response) => {
					this.dispatch("moduleStatusMobile/getStatusMobile");
					//commit('UPDATE_STATUS', response.data)
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Elimina el Status
	removeStatus({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/status/mobile/${itemId}`)
				.then((response) => {
					commit("REMOVE_STATUS", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
